export const COMMON_CANDIDACY_PARTIES = [
  "Democratic",
  "Republican",
  "Independent",
  "Green",
  "Libertarian",
] as const;

const PARTY_ALIASES = new Map<string, string>([
  ["d", "Democratic"],
  ["dem", "Democratic"],
  ["democrat", "Democratic"],
  ["democratic", "Democratic"],
  ["democratic party", "Democratic"],
  ["r", "Republican"],
  ["rep", "Republican"],
  ["republican", "Republican"],
  ["republican party", "Republican"],
  ["g", "Green"],
  ["green", "Green"],
  ["green party", "Green"],
  ["libertarian", "Libertarian"],
  ["libertarian party", "Libertarian"],
  ["independent", "Independent"],
]);

export const isNonpartisanParty = (party: string) =>
  /^non-?partisan$/i.test(party);

/**
 * Canonicalize known aliases without closing the vocabulary. Party is
 * optional—blank is the normal representation for a nonpartisan candidacy.
 */
export function normalizeCandidacyParty(
  value: string | null | undefined
): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return PARTY_ALIASES.get(trimmed.toLowerCase()) ?? trimmed;
}
